import MockAdapter from 'axios-mock-adapter';

export function securityMocks(mock: MockAdapter): void {
  mock
    .onGet(/\/api\/security\/organization\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/)
    .reply(() => {
      const result = [
        {
          name: 'FORM',
          read: true,
          write: true,
          delete: true,
          update: true,
        },
        { name: 'FORM_SUBMISSION', read: true, write: true, delete: true, update: true },
        { name: 'REPORT', read: true, write: true, delete: true, update: true },
        { name: 'PAYMENT_ACCOUNTS', read: true, write: true, delete: true, update: true },
        { name: 'ORGANIZATION', read: true, write: true, delete: true, update: true },
      ];
      return [200, result];
    });
}
